module.exports = __webpack_public_path__ + "img/Sport,  Freizeit & Reisen.a1260290.jpg";